import { Stack } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import { FaYoutube } from "react-icons/fa";
import SearchBar from "./SearchBar";

const Navbar = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      p={2}
      sx={{
        position: "sticky",
        background: "#000",
        top: "0",
        justifyContent: "space-between",
      }}
    >
      <Link
        to="/"
        style={{ display: "flex", color: "red", alignItems: "center" }}
      >
        <div style={{ fontSize: "45px" }}>
          <FaYoutube />
        </div>
      </Link>
      <SearchBar />
    </Stack>
  );
};

export default Navbar;
